import type * as http from 'node:http';
import type * as net from 'node:net';

function isServerNotRunningError(err: NodeJS.ErrnoException): boolean {
  return err.code === 'ERR_SERVER_NOT_RUNNING';
}

/** Idempotent HTTP server close for CLI teardown (ignores already-closed servers). */
export function closeHttpServer(server: http.Server | net.Server | null): Promise<void> {
  if (!server) return Promise.resolve();
  return new Promise((resolve) => {
    server.close((err) => {
      if (err && !isServerNotRunningError(err)) {
        /* teardown must not block exit */
      }
      resolve();
    });
  });
}
